<template>
  <section class="slide-1">
    <firstAnimation
      class="relative h-125 w-screen overflow-hidden"
      :mobile="true"
    />
    <h2
      class="px-4.5 w-screen fz-22 -mt-11 mb-12.5"
      style="line-height: 1.875rem"
    >
      {{ text.agency[0] }} {{text.agency[1]}}
    </h2>
    <div class="flex px-4.5 w-screen mb-25">
      <a
        href="#mobile-start"
        @click="setRoute('blog')"
        class="news pt-2 flex flex-col flex-shrink-0 mr-10"
        style="color: rgba(255, 46, 83, 1)"
      >
        <p class="mb-6 fz-10">{{ text.news.hot }}</p>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke="#ff2e53"
            d="M12 17L19 10L12 3"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M5 10L19 10"
            stroke="#ff2e53"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <p
        class="fz-15 font-medium"
        style="line-height: 1.6; color: rgba(192, 197, 216, 1)"
      >
        {{ text.news.text[0]}}
        {{ text.news.text[1]}}
        {{ text.news.text[2]}}
        {{ text.news.text[3]}}
      </p>
    </div>
    <section class="services fz-16 font-medium flex flex-col mb-33.75">
      <div
        class="service-m flex flex-col px-7.5 mx-4.5 mb-2.5"
        @click="adds[0] = !adds[0]"
      >
        <div class="flex items-center justify-between py-3.75">
          <img
            class="w-12.5 h-12.5"
            src="@/assets/images/slide_1/service_icons/loader.svg"
            alt=""
          />
          <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.services[0].title }}</p>
        </div>
        <div
          class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25"
          :class="{ 'h-31.25 pt-2.5 pb-7.5': adds[0], 'h-0 p-0': !adds[0] }"
        >
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[0].points[0] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[0].points[1] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[0].points[2] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="service-m flex flex-col px-7.5 mx-4.5 mb-2.5"
        @click="adds[1] = !adds[1]"
      >
        <div class="flex items-center justify-between py-3.75">
          <img
            class="w-12.5 h-12.5"
            src="@/assets/images/slide_1/service_icons/globe.svg"
            alt=""
          />
          <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.services[1].title }}</p>
        </div>
        <div
          class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25"
          :class="{ 'h-31.25 pt-2.5 pb-7.5': adds[1], 'h-0 p-0': !adds[1] }"
        >
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[1].points[0] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[1].points[1] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[1].points[2] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="service-m flex flex-col px-7.5 mx-4.5 mb-2.5"
        @click="adds[2] = !adds[2]"
      >
        <div class="flex items-center justify-between py-3.75">
          <img
            class="w-12.5 h-12.5"
            src="@/assets/images/slide_1/service_icons/radio.svg"
            alt=""
          />
          <p class="fz-18 uppercase" style="line-height: 1.666rem">
            {{ text.services[2].title }}
          </p>
        </div>
        <div
          class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25"
          :class="{ 'h-31.25 pt-2.5 pb-7.5': adds[2], 'h-0 p-0': !adds[2] }"
        >
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[2].points[0] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[2].points[1] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[2].points[2] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="service-m flex flex-col px-7.5 mx-4.5 mb-2.5"
        @click="adds[3] = !adds[3]"
      >
        <div class="flex items-center justify-between py-3.75">
          <img
            class="w-12.5 h-12.5"
            src="@/assets/images/slide_1/service_icons/pen-tool.svg"
            alt=""
          />
          <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.services[3].title }}</p>
        </div>
        <div
          class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25"
          :class="{ 'h-31.25 pt-2.5 pb-7.5': adds[3], 'h-0 p-0': !adds[3] }"
        >
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[3].points[0] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[3].points[1] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
          <div class="flex items-center ml-auto justify-end">
            <p class="mr-5" style="line-height: 1.5625">{{ text.services[3].points[2] }}</p>
            <div class="w-5 h-5 relative">
              <div
                class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
              <div
                class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                style="background: rgba(110, 117, 141, 1)"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="service-m flex flex-col px-7.5 mx-4.5 mb-2.5"
        @click="adds[4] = !adds[4]"
      >
        <div class="flex items-center justify-between py-3.75">
          <img
            class="w-12.5 h-12.5"
            src="@/assets/images/slide_1/service_icons/smile.svg"
            alt=""
          />
          <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.services[4].title }}</p>
        </div>
        <div
          class="dop overflow-hidden flex"
          :class="{ 'h-31.25 pt-2.5 pb-7.5': adds[4], 'h-0 p-0': !adds[4] }"
        >
          <div
            class="flex items-center ml-auto w-55p text-right mt-auto justify-end items-end"
          >
            <p style="line-height: 1.5625">{{ text.services[4].points[0] }} {{ text.services[4].points[1] }}</p>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import firstAnimation from "../../desktop/slide1/firstAnimation";
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide1",
  components: { firstAnimation },
  data() {
    return {
      adds: [false, false, false, false, false],
    };
  },
  methods:{
    ...mapMutations(['setRoute'])
  },
  computed:{
    text(){
      return {
        ...require("@/assets/text/main/slide1/" + this.lang + ".json"),
        ...require("@/assets/text/fixWrappers/" + this.lang + ".json"),
      };
    },
    ...mapState(['lang'])
  }
};
</script>

<style scoped lang="scss">
.service-m {
  background: rgba(110, 117, 141, 0.1);
}
.dop {
  transition: all 0.35s ease-out;
}
</style>
